const productDescription = ()=>({
    expanded: false,
    isOverflowing: false,
    init(){
        
        this.checkOverflow();
    },
    toggleDescription(){
        this.expanded = !this.expanded;
    },
    checkOverflow() {
        this.$nextTick(() => {
            const content = this.$refs.description;
            console.log(content.scrollHeight)
            this.isOverflowing = content.scrollHeight >= 62;
        });
    },
})

export default productDescription

window.addEventListener("alpine:init", ()=>{
    Alpine.data("description", productDescription)
})

